import { call } from 'typed-redux-saga';
import {
  AsyncActionState,
  asyncActionStateMatchers,
  setupSlice,
  SagaGenerator,
} from '@owl-frontend/redux';
import { addFeedback as addFeedbackApi } from '../../api/feedback/client';
import { Feedback } from '../../api/feedback/interface';

function* addFeedback(action: { payload: Feedback }): SagaGenerator<Feedback> {
  yield* call(addFeedbackApi, action.payload);
  return action.payload;
}

export interface FeedbackState {
  actions: {
    addFeedback: AsyncActionState;
  };
}

const initialState: FeedbackState = {
  actions: {
    addFeedback: { status: 'uninitialized' },
  },
};

const slice = setupSlice('feedback', initialState)
  .addAsyncSagas({
    addFeedback,
  })
  .addReducers({});

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
